export function averageMonthlyCost(a, b) {
    if (a && a.data && !a.data.costs)
        return 1;
    if (b && b.data && !b.data.costs)
        return -1;
    return a.data.costs.averageMonthlyCost > b.data.costs.averageMonthlyCost ? 1 : -1;
}
export function contractLengthInMonths(a, b) {
    if (a && a.data && !a.data.contractLengthInMonths)
        return 1;
    if (b && b.data && !b.data.contractLengthInMonths)
        return -1;
    return a.data.contractLengthInMonths > b.data.contractLengthInMonths ? 1 : -1;
}
export function totalFirstYearCost(a, b) {
    if (a && a.data && !a.data.costs?.totalFirstYearCost)
        return 1;
    if (b && b.data && !b.data.costs?.totalFirstYearCost)
        return -1;
    return a.data.costs.totalFirstYearCost > b.data.costs.totalFirstYearCost ? 1 : -1;
}
export function totalContractCost(a, b) {
    if (a && a.data && !a.data.costs?.totalContractCost)
        return 1;
    if (b && b.data && !b.data.costs?.totalContractCost)
        return -1;
    return a.data.costs.totalContractCost > b.data.costs.totalContractCost ? 1 : -1;
}
export function totalUpfrontCost(a, b) {
    if (a && a.data && !a.data.costs?.totalUpfrontCost)
        return 1;
    if (b && b.data && !b.data.costs?.totalUpfrontCost)
        return -1;
    return a.data.costs.totalUpfrontCost > b.data.costs.totalUpfrontCost ? 1 : -1;
}
export function averageDownloadSpeedKbps(a, b) {
    if (a && a.data && !a.data.broadband)
        return 1;
    if (b && b.data && !b.data.broadband)
        return -1;
    return a.data.broadband.averageDownloadSpeedKbps < b.data.broadband.averageDownloadSpeedKbps ? 1 : -1;
}
export function downloadLimit(a, b) {
    if (a && a.data && !a.data.broadband)
        return 1;
    if (b && b.data && !b.data.broadband)
        return -1;
    return a.data.broadband.downloadLimit > b.data.broadband.downloadLimit ? 1 : -1;
}
